import{styled as o}from"styled-components";const n=/*#__PURE__*/o.div.withConfig({displayName:"Column",componentId:"sc-cfc52180-0"})(["display:flex;flex-direction:column;"]);export{n as Column};
